import React from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tooltip } from '@mui/material';
import { Checkbox } from 'primereact/checkbox';
import {
  styledCheckboxHeader,
  styledColumnHeaderCheckbox
} from '../../../components/layout/main/mainStyles';
import { LoadingRowsComponent } from '../../../components/commons/LoadingRows/LoadingRows';
import { IScene } from '../../../types/Scenes/scenesTypes';
import { ContainerTable } from '../../locations/locationsList/locationListStyles';
import { maxCharactersString } from '../../../utils/commonUtils';
import { ISequenceResponse } from '../../../types/sequences/sequencesInterface';

interface ILightShowsListTemplateProps {
  selectedLightShows: any[];
  setSelectedLightShows: (selectedScenes: any[]) => void;
  lightShows: ISequenceResponse[];
  isLoading: boolean;
}
export const LightShowsListTemplate = ({
  selectedLightShows,
  setSelectedLightShows,
  lightShows,
  isLoading
}: ILightShowsListTemplateProps) => {
  const getHeaderCheckbox = () => {
    return (
      <Checkbox
        className="p-checkbox"
        style={{
          visibility: selectedLightShows.length > 0 ? 'visible' : 'hidden',
          ...styledCheckboxHeader
        }}
        checked={selectedLightShows.length > 0}
        onChange={() => {
          setSelectedLightShows([]);
        }}
      />
    );
  };

  return (
    <>
      {isLoading && <LoadingRowsComponent />}
      {!isLoading && lightShows && (
        <ContainerTable component="main">
          <DataTable
            selection={selectedLightShows}
            selectionMode="multiple"
            metaKeySelection
            onSelectionChange={(e) => setSelectedLightShows(e.value)}
            className="mt-3"
            rowHover
            value={lightShows}
            size="small"
            scrollable
            scrollHeight="flex"
            paginator={lightShows && lightShows.length >= 50}
            selectionPageOnly
            rows={50}
            rowsPerPageOptions={[
              5,
              10,
              20,
              50,
              lightShows ? lightShows.length : 50
            ]}
            tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
          >
            <Column
              selectionMode="multiple"
              headerStyle={styledColumnHeaderCheckbox}
              header={getHeaderCheckbox}
              frozen
            />
            <Column field="id" header="Id" sortable />
            <Column field="name" header="Name" sortable />
            <Column field="sequenceTypeName" header="Type" sortable />
          </DataTable>
        </ContainerTable>
      )}
    </>
  );
};
